import { Tag } from "@jutro/ui";
import dayjs from "dayjs";

type Props = {
  time: string;
  isConfirmedShift: boolean;
};

export const TimeTagCell = ({ time, isConfirmedShift }: Props) => {
  return (
    <div className="flex h-6 items-center">
      <Tag
        text={dayjs(time).format("HH:mm")}
        variant={isConfirmedShift ? "inverted" : "default"}
        color={isConfirmedShift ? "green" : "blue"}
      />
    </div>
  );
};
